import React, { FC } from 'react';
import { PIE_CHART_MAX_SLICE_COUNT } from '../../../utils/constants';

type Props = {
  data: Array<number>;
  renderItems: (
    data: Array<{
      clickable: boolean;
      value: number;
      i: number;
    }>,
  ) => React.ReactNode;
};

export const ChartLegendList: FC<Props> = ({ data, renderItems, children }) => {
  // last pie chart is not clickable as it is "other"
  return (
    <ul>
      {renderItems(
        data.map((value, i) => ({
          clickable: i < PIE_CHART_MAX_SLICE_COUNT - 1,
          value,
          i,
        })),
      )}
      {children}
    </ul>
  );
};
